@if (config; as brand) {
  <div class="bg-navigation text-navigation-text">
    <div class="mx-auto flex max-w-[1240px] items-center justify-between gap-4 px-4 py-2 text-xs sm:px-6">
      <div class="flex min-w-0 items-center gap-4 sm:gap-5">
        @if (brand.site.supportNumber) {
          <a
            class="focus-ring inline-flex items-center gap-1.5 truncate text-navigation-text/80 transition hover:text-navigation-text"
            [href]="supportPhoneHref">
            <svg class="size-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            {{ brand.site.supportNumber }}
          </a>
        }
        @if (brand.site.supportEmail) {
          <a
            class="focus-ring hidden items-center gap-1.5 truncate text-navigation-text/80 transition hover:text-navigation-text sm:inline-flex"
            [href]="supportEmailHref">
            <svg class="size-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="2"/>
              <path d="m3 7 9 6 9-6"/>
            </svg>
            {{ brand.site.supportEmail }}
          </a>
        }
      </div>
      <div class="flex items-center gap-3">
        @if (brand.socialLinks.facebook) {
          <a class="focus-ring text-navigation-text/70 transition hover:text-navigation-text" [href]="brand.socialLinks.facebook" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <svg class="size-3.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2.5V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1 0 2 .1 2.3.2v2.7h-1.5c-1.2 0-1.5.6-1.5 1.4V12h2.9l-.4 2.9h-2.5v7A10 10 0 0 0 22 12z"/></svg>
          </a>
        }
        @if (brand.socialLinks.twitter) {
          <a class="focus-ring text-navigation-text/70 transition hover:text-navigation-text" [href]="brand.socialLinks.twitter" target="_blank" rel="noopener noreferrer" aria-label="X / Twitter">
            <svg class="size-3.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.9 2H22l-6.8 7.8L23.2 22H17l-4.8-6.3L6.7 22H3.6l7.1-8.1L1.8 2h6.4l4.4 5.8L18.9 2Zm-1.1 17.8h1.7L7.3 4H5.5l12.3 15.8Z"/></svg>
          </a>
        }
        @if (!brand.socialLinks.facebook && !brand.socialLinks.twitter) {
          <span class="hidden text-navigation-text/70 sm:inline">Secure online booking</span>
        }
      </div>
    </div>
  </div>

  <header class="sticky top-0 z-60 border-b border-line-soft bg-surface/95 backdrop-blur">
    <div class="mx-auto flex max-w-[1240px] items-center justify-between gap-6 px-4 py-3 sm:px-6 lg:py-3.5">
      <a routerLink="/" class="focus-ring flex min-w-0 shrink-0 items-center" [attr.aria-label]="brand.site.name + ' home'">
        @if (brand.self.logo) {
          <img class="h-9 max-w-40 object-contain sm:h-10" [src]="brand.self.logo" [alt]="brand.site.name">
        } @else {
          <span class="truncate font-display text-lg font-extrabold text-ink">{{ brand.site.name }}</span>
        }
      </a>

      <nav class="hidden flex-1 items-center justify-center gap-7 lg:flex" aria-label="Main navigation">
        <a routerLink="/" routerLinkActive="text-brand" [routerLinkActiveOptions]="{ exact: true }" class="focus-ring text-sm font-bold text-ink transition hover:text-brand">Home</a>
        <a routerLink="/parcel" [style.color]="isActiveRoute('/parcel') ? 'var(--color-primary)' : null" class="focus-ring text-sm font-semibold text-ink transition hover:text-brand">Parcels</a>
        <a routerLink="/about-us" [style.color]="isActiveRoute('/about-us') ? 'var(--color-primary)' : null" class="focus-ring text-sm font-semibold text-ink transition hover:text-brand">About us</a>
        <a routerLink="/contact-us" [style.color]="isActiveRoute('/contact-us') ? 'var(--color-primary)' : null" class="focus-ring text-sm font-semibold text-ink transition hover:text-brand">Contact us</a>
      </nav>

      <div class="flex shrink-0 items-center gap-2">
        <!-- Download-app link temporarily hidden until the app promotion is restored.
        @if (hasMobileApp) {
          <a
            routerLink="/"
            fragment="download-app"
            class="focus-ring hidden items-center gap-2 rounded-xl border border-line px-4 py-2.5 text-sm font-bold text-ink transition hover:border-brand hover:text-brand md:inline-flex">
            <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M10 18h4"/></svg>
            Download app
          </a>
        } -->
        @if (!isLoggedIn) {
            <button type="button" class="auth-signin-trigger focus-ring hidden rounded-xl bg-brand px-5 py-2.5 text-sm font-bold text-brand-contrast transition hover:opacity-90 md:inline-flex" data-toggle="modal" data-target="#loginPopupForm">Sign in</button>
        } @else {
          <div class="relative hidden md:block">
            <button
              type="button"
              class="focus-ring inline-flex items-center gap-2 rounded-xl border border-line bg-white px-2.5 py-2 text-left text-ink transition hover:border-brand"
              aria-haspopup="menu"
              [attr.aria-expanded]="accountOpen"
              (click)="toggleAccount()">
              <span class="inline-flex size-8 items-center justify-center rounded-full bg-brand text-xs font-extrabold text-brand-contrast" aria-hidden="true">{{ accountInitials }}</span>
              <span class="hidden min-w-0 lg:block">
                <small class="block text-[10px] font-semibold leading-none text-slate-500">Signed in</small>
                <strong class="mt-1 block max-w-28 truncate text-xs leading-none">{{ accountFirstName }}</strong>
              </span>
              <svg class="size-4 text-slate-400 transition-transform" [class.rotate-180]="accountOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
            </button>

            @if (accountOpen) {
              <div
                class="absolute right-0 top-full z-70 mt-2 w-64 overflow-hidden rounded-2xl border border-line-soft bg-white shadow-[0_18px_45px_rgba(16,24,40,0.16)]"
                role="menu"
                aria-label="Signed-in account menu">
                <div class="border-b border-line-soft px-4 py-3">
                  <strong class="block truncate text-sm text-ink">{{ accountName }}</strong>
                  <span class="mt-1 block truncate text-xs text-slate-500">{{ accountIdentifier }}</span>
                </div>
                <div class="grid gap-1 p-2">
                  <a routerLink="/my-booking" role="menuitem" class="focus-ring flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-semibold text-ink transition hover:bg-gray-50" (click)="closeAccount()">
                    <svg class="size-4 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/></svg>
                    My bookings
                  </a>
                  <a routerLink="/user-profile" role="menuitem" class="focus-ring flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-semibold text-ink transition hover:bg-gray-50" (click)="closeAccount()">
                    <svg class="size-4 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg>
                    My profile
                  </a>
                  <button type="button" role="menuitem" class="focus-ring flex w-full items-center gap-3 rounded-xl border-0 bg-transparent px-3 py-2.5 text-left text-sm font-semibold text-red-600 transition hover:bg-red-50" (click)="logoutUser()">
                    <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5M21 12H9"/></svg>
                    Log out
                  </button>
                </div>
              </div>
            }
          </div>
        }
        <button
          type="button"
          class="focus-ring inline-flex size-11 items-center justify-center rounded-xl border border-line bg-gray-50 text-ink lg:hidden"
          aria-label="Open navigation menu"
          [attr.aria-expanded]="mobileOpen"
          aria-controls="mobile-navigation"
          (click)="toggleMobile($event)">
          <svg class="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M3 6h18M3 12h18M3 18h18"/>
          </svg>
        </button>
      </div>
    </div>
  </header>

  @if (mobileOpen) {
    <button
      type="button"
      class="fixed inset-0 z-80 cursor-default bg-slate-950/50"
      aria-label="Close navigation menu"
      (click)="closeMobile()"></button>
    <aside
      id="mobile-navigation"
      class="fixed inset-y-0 right-0 z-90 flex w-[min(88vw,360px)] flex-col bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-label="Navigation menu">
      <div class="flex items-center justify-between border-b border-line-soft px-5 py-4">
        <span class="font-display text-base font-extrabold text-ink">{{ brand.site.name }}</span>
        <button type="button" class="focus-ring inline-flex size-10 items-center justify-center rounded-full bg-gray-100 text-ink" aria-label="Close navigation menu" (click)="closeMobile()">
          <svg class="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m18 6-12 12M6 6l12 12"/></svg>
        </button>
      </div>
      <nav class="flex flex-1 flex-col gap-1 overflow-y-auto p-4" aria-label="Mobile navigation">
        @if (isLoggedIn) {
          <div class="mb-3 flex items-center gap-3 rounded-2xl bg-gray-50 p-3">
            <span class="inline-flex size-10 items-center justify-center rounded-full bg-brand text-sm font-extrabold text-brand-contrast" aria-hidden="true">{{ accountInitials }}</span>
            <div class="min-w-0">
              <strong class="block truncate text-sm text-ink">{{ accountName }}</strong>
              <span class="mt-0.5 block truncate text-xs text-slate-500">{{ accountIdentifier }}</span>
            </div>
          </div>
        }
        <a routerLink="/" [style.color]="isActiveRoute('/') ? 'var(--color-primary)' : null" class="focus-ring rounded-xl px-4 py-3 text-base font-bold text-ink hover:bg-gray-50" (click)="closeMobile(false)">Home</a>
        <a routerLink="/parcel" [style.color]="isActiveRoute('/parcel') ? 'var(--color-primary)' : null" class="focus-ring rounded-xl px-4 py-3 text-base font-semibold text-ink hover:bg-gray-50" (click)="closeMobile(false)">Parcels</a>
        <a routerLink="/about-us" [style.color]="isActiveRoute('/about-us') ? 'var(--color-primary)' : null" class="focus-ring rounded-xl px-4 py-3 text-base font-semibold text-ink hover:bg-gray-50" (click)="closeMobile(false)">About us</a>
        <a routerLink="/contact-us" [style.color]="isActiveRoute('/contact-us') ? 'var(--color-primary)' : null" class="focus-ring rounded-xl px-4 py-3 text-base font-semibold text-ink hover:bg-gray-50" (click)="closeMobile(false)">Contact us</a>
        <!-- Download-app link temporarily hidden until the app promotion is restored.
        @if (hasMobileApp) {
          <a routerLink="/" fragment="download-app" class="focus-ring flex items-center gap-2 rounded-xl px-4 py-3 text-base font-semibold text-ink hover:bg-gray-50" (click)="closeMobile(false)">
            <svg class="size-5 text-brand" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M10 18h4"/></svg>
            Download app
          </a>
        } -->
        @if (isLoggedIn) {
          <a routerLink="/user-profile" class="focus-ring rounded-xl px-4 py-3 text-base font-semibold text-ink hover:bg-gray-50" (click)="closeMobile(false)">My profile</a>
          <a routerLink="/my-booking" class="focus-ring rounded-xl px-4 py-3 text-base font-semibold text-ink hover:bg-gray-50" (click)="closeMobile(false)">My bookings</a>
        }
      </nav>
      <div class="grid gap-2 border-t border-line-soft p-4">
        @if (!isLoggedIn) {
            <button type="button" class="auth-signin-trigger focus-ring rounded-xl bg-brand px-4 py-3 text-sm font-bold text-brand-contrast" data-toggle="modal" data-target="#loginPopupForm" (click)="closeMobile(false)">Sign in</button>
        } @else {
          <button type="button" class="focus-ring rounded-xl bg-brand px-4 py-3 text-sm font-bold text-brand-contrast" (click)="logoutUser(); closeMobile(false)">Log out</button>
        }
      </div>
    </aside>
  }
}
